// react library imports
import { NavLink } from "react-router-dom";
import "./Shimmer.css";

const FooterCard = ({title, list}) => {
  return (
    <div className='mues_navigation_card mues_column_space_between
    mues_row_gap_16 footer_card_container'>
        <h6 className='mues_font_weight_600'>{title}</h6>
        <ul className=' mues_column_space_between
        mues_row_gap_8'>
            {list.map(item=>{
              if (item.name ==="mues PRO") return(
                <div key={item.id}>
                  <NavLink className='mues_navigation_card_item
                  mues_pointer' to={item.path}>
                    <button className="shimmer_button">
                    </button>
                  </NavLink>
                </div>
              )
              return(
                <div key={item.id}>
                  <NavLink className='mues_navigation_card_item mues_one_line_clamp
                  mues_pointer mues_white' to={item.path}
                  >{item.name}</NavLink>
                </div>
              )
            })}
        </ul>
    </div>
  )
}

export default FooterCard